module.exports = __webpack_public_path__ + "img/warning.5577f221.svg";